import { Card, Row, Col } from 'react-bootstrap';
import { useEffect, useRef, useState } from "react";
import moment from "moment";
import loader from "../assets/images/loader.gif";
import "./Invoice.scss"
import HelperService from '../utility/HelperService';
import WebService from '../utility/WebService';
import { Button } from "../Button/Button";
import Loader from '../Loader/Loader';
import Modal from 'react-bootstrap/Modal';
import { Label } from '../Label/Label';
import { PlusSquare } from "react-bootstrap-icons";
import { toast } from 'react-toastify';

interface PropData {
    InvoiceData?: any;
    showLoader?: boolean;
    type?: string;
    receipt?: any;
    code?: string;
    payment?: boolean;
    // Trigger parent to refresh payment tab
    onPaymentDone?: any;
}



const InvoiceDetailHeader = (props: PropData) => {
    const [isLoading, setLoading] = useState(false);
    const [invoiceData, setInvoiceData] = useState<any>({});
    const [downPayment, setDownPayment] = useState(0);
    const [savedCardsData, setSavedCardsData] = useState<any[]>([]);
    const [selectedCard, setSelectedCard] = useState<any>();
    const [finalAmount, setFinalAmount] = useState<any>();
    const [authKeyData, setAuthKeyData] = useState<any>();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const value = encodeURIComponent(urlParams.get('amount') || "");
    const [show, setShow] = useState(false);
    const [feeData, setFeeData] = useState<any>();
    const [isPaymentDone, setIsPaymentDone] = useState(false);
    const [isACHEnabled, setIsACHEnabled] = useState(false);
    const[isAmountEditable, setIsAmountEditable] = useState(false);
    const [achMaxAmount, setACHMaxAmount] = useState<any>();
    const paymentResponse = useRef<any>()
    var result = props.InvoiceData?.menuItems && props.InvoiceData?.menuItems.find((obj: any) => {
        return (obj.menuCode == 'Paymentinfo' || obj.menuCode == 'PaymentInfo');
    })
    var total_amount = 0
    if (feeData?.transactionFeeEnabled) {
        if (!feeData?.checkSalesAmtMin || feeData?.checkSalesAmtMin && Number(finalAmount) > Number(feeData?.salesAmountLowerCeiling)) {
            total_amount = Number(((feeData?.transactionFeePerc / 100) * finalAmount).toFixed(2))
        }
    }

    useEffect(() => {
        setInvoiceData(props.InvoiceData)
        getPaymentData()
        setIsACHEnabled(props.InvoiceData?.achInfo?.achEnabled)
        setACHMaxAmount(props.InvoiceData?.achInfo?.achMaxAmount)
       // setACHMaxAmount(60)
    }, [props.InvoiceData]);

    useEffect(() => {
        if (paymentResponse.current) {
            if(selectedCard=="NEW_ACH_CARD") 
                addACHCard(paymentResponse.current)
            else
                 addNewCard(paymentResponse.current)
        }
        getFees()
    }, [isPaymentDone])

    useEffect(() => {
        const depositRef = props?.InvoiceData?.callInfo?.depositRef;
        const refNum1 = props?.InvoiceData?.callInfo?.paymentRefNum1;
        const refNum2 = props?.InvoiceData?.callInfo?.paymentRefNum2;
        const effectivePmt1 = refNum1 ? Number(props?.InvoiceData?.callInfo?.paymentAmt1) : 0;
        const effectivePmt2 = refNum2 ? Number(props?.InvoiceData?.callInfo?.paymentAmt2) : 0;
        const effectiveDeposit = (depositRef && (depositRef === refNum1 || depositRef === refNum2)) ? 0 : Number(props?.InvoiceData?.callInfo?.depositAmt);
        var value = (Number(props?.InvoiceData?.callInfo?.invTotalAmt) - (effectiveDeposit + effectivePmt1 + effectivePmt2));
        if(Number(value) <=0 ) value = 0;
        setDownPayment(value)
       if(effectivePmt1 <=0 ) setIsAmountEditable(true);
        // setInvoiceData(props?.InvoiceData?.callInfo)
        if (props.payment && value) {
            getAuthorizationKey()
        }
    }, [props?.InvoiceData?.payments])

    const getPaymentData = () => {
        WebService.getAPI({
            action: `api/Invoice/customerInvoicePayments?CompanyCode=${props?.code}&InvoiceNumber=${props?.InvoiceData?.callInfo?.invoiceNum}`
        })
            .then((res: any) => {
                const depositRef = res?.data?.depositRef;
                const refNum1 = res?.data?.paymentRefNum1;
                const refNum2 = res?.data?.paymentRefNum2;
                const effectivePmt1 = refNum1 ? Number(res?.data?.paymentAmt1) : 0;
                const effectivePmt2 = refNum2 ? Number(res?.data?.paymentAmt2) : 0;
                const effectiveDeposit = (depositRef && (depositRef === refNum1 || depositRef === refNum2)) ? 0 : Number(res?.data?.depositAmt);
                props.InvoiceData.callInfo.paymentAmt1 = res?.data?.paymentAmt1
                props.InvoiceData.callInfo.paymentAmt2 = res?.data?.paymentAmt2
                props.InvoiceData.callInfo.paymentRefNum1 = refNum1
                props.InvoiceData.callInfo.paymentRefNum2 = refNum2
                props.InvoiceData.callInfo.depositRef = depositRef
                props.InvoiceData.callInfo.amountPaid = Math.round((effectivePmt1 + effectivePmt2) * 100) / 100;
                var value = Math.round((Number(res?.data?.invTotalAmt) - (effectiveDeposit + effectivePmt1 + effectivePmt2)) * 100) / 100;
                if(Number(value) <=0 ) value = 0;
                setDownPayment(value)
                props.InvoiceData.callInfo.amountDue = value
                if(effectivePmt1 <=0 ) setIsAmountEditable(true);
            })
            .catch((e) => {
            })
    }

    const getSavedCards = () => {
        WebService.getAPI({
            action: `api/CreditCard/getSavedCreditCards?CompanyCode=${props?.code}&BillTo=${props?.InvoiceData?.billTo?.billTo}`
        })
            .then((res: any) => {
                setSavedCardsData(res.data)
                if (res.data.length == 0) {
                    setSelectedCard('NEW_CARD')
                } else {
                    setSelectedCard(res?.data[0]?.sequence)
                }
            })
            .catch((e) => {

            })
    }

    const getAuthorizationKey = () => {
        setLoading(true)
        WebService.postAPI({
            action: `api/CreditCard/GetFSAuthenticationKey`,
            body: {
                CompanyCode: props.code
            }
        })
            .then((res: any) => {
                setLoading(false)
                setAuthKeyData(res.data)
                if (props.payment && value) {
                    openModal()
                } else {
                    setShow(true)
                }
            })
            .catch((e) => {
                setLoading(false)
            })
    }

    const handleClose = () => {
        setShow(false);
        getPaymentData();    
        setInvoiceData(props.InvoiceData);
        if((Math.round((Number(props?.InvoiceData?.callInfo?.paymentAmt1))* 100) / 100) <=0 ) setIsAmountEditable(true);
        // Trigger parent to refresh payment tab
         props.onPaymentDone();
    }

    var data: any = {
        "authenticationKey": authKeyData?.authenticationKey,// should get from server
        "operationType": "HostedPaymentsAccountId",
        "paymentSourceType": "Card",
        "cardEntryContext": "WebConsumerInitiated",
        "achAuthorizationType": "Web",
        "nameOnAccountField": "NameOnAccount",
        "zipField": "Zip",
        "showNameOnAccount": true,
        "showZip": true,
        "formId": "tokenForm",
       // "completionCallback": "",
        "hostedPaymentURL": authKeyData?.hostedPaymentURL
    };

      var achData: any ={
        "authenticationKey": authKeyData?.authenticationKey,// should get from server
        "operationType": "HostedPaymentsAccountId",
        "paymentSourceType": "ACH",
       // "cardEntryContext": "WebConsumerInitiated",
        "achAuthorizationType": "Web",
        "nameOnAccountField": "NameOnAccount",
        "zipField": "Zip",
        "showNameOnAccount": true,
        "showZip": true,
        "formId": "tokenForm",
        "customerId": props?.InvoiceData?.billTo?.billTo,
        "invoiceNumber": props?.InvoiceData?.callInfo?.invoiceNum,
       // "completionCallback": "",
        "hostedPaymentURL": authKeyData?.hostedPaymentURL

    };
    const openModal = () => {
        if (authKeyData?.authenticationKey) {
            const channel = new BroadcastChannel("OPEN_HOSTED_PAYMENT");
            if(selectedCard == "NEW_ACH_CARD"){
            if (props.payment && value) {
                achData.total_amount = Number(value).toFixed(2)
                } else {
                    achData.total_amount = Number(finalAmount).toFixed(2)
                }
            channel.postMessage(achData);
             }
             else
             {
               if (props.payment && value) {
                data.total_amount = Number(value).toFixed(2)
                } else {
                    data.total_amount = Number(finalAmount + total_amount).toFixed(2)
                }
             channel.postMessage(data);
             }
              }
            };

    const channel = new BroadcastChannel("OPEN_HOSTED_PAYMENT_CALLBACK");
    channel.onmessage = (event) => {
        if (event?.data) {
            setIsPaymentDone(true)
            paymentResponse.current = event.data
            data.completionCallback = function () {
            handleClose();
      };
      }
        if (event?.data?.gatewayResponse) {

        }
    };


    const onMakePayment = () => {
        var total_amount = Number(finalAmount)
        if (feeData?.transactionFeeEnabled) {
            if (!feeData?.checkSalesAmtMin || feeData?.checkSalesAmtMin && Number(finalAmount) > Number(feeData?.salesAmountLowerCeiling)) {
                var value = ((feeData?.transactionFeePerc / 100) * finalAmount).toFixed(2)
                total_amount += Number(value)
            }
        }
        setLoading(true)
        WebService.postAPI({
            action: `api/CreditCard/ChargeWithTokenMultipleInvoices`,
            body: {
                CompanyCode: props.code,
                Sequence: selectedCard,
                BillTo: props?.InvoiceData?.billTo?.billTo,
                AmountToCharge: total_amount,
                UserNumber: '',
                UserName: 'CUSTOMER',
                UserType: 'C',
                TransactionFee: 0,
                Comments: '',
                Invoices: [
                    {
                        Module: 'SD',
                        InvoiceNum: props?.InvoiceData?.callInfo?.invoiceNum.toString(),
                        Amount: Number(finalAmount)
                    }
                ]
            }
        })
            .then((res: any) => {
                setLoading(false)
                if (res.success == true && res.data.status == 'Approved') {
                    toast.success('Payment done successfully')
                    getPaymentData();
                    handleClose();
                } else {
                    toast.error(res?.errorInfo?.message)
                }
            })
            .catch((e) => {
                setLoading(false)
                toast.error(e?.response?.data?.errorInfo?.message)
            })
    }

    const getFees = () => {
        WebService.getAPI({
            action: `api/CreditCard/getProgramFeesInfo?CompanyCode=113&TechNum=105`
        })
            .then((res: any) => {
                setFeeData(res.data)
            })
            .catch((e) => {

            })
    }

    const addNewCard = (data: any) => {
        setLoading(true)
        var value = data && JSON.parse(data)
        WebService.postAPI({
            action: `api/CreditCard/ChargeWithTokenMultipleInvoicesNewCard`,
            body: {
                CompanyCode: props.code,
                NewCardToken: value?.gatewayResponse?.hostedPaymentsAccountId,
                NewCardName: 'test',
                NewCardLast4: value?.requestDetails?.cardNumber,
                BillTo: props?.InvoiceData?.billTo?.billTo,
                AmountToCharge: finalAmount,
                UserNumber: '',
                UserName: 'CUSTOMER',
                UserType: 'C',
                TransactionFee: 0,
                sendReceiptToEmail: '',
                sendReceiptToPhone: '',
                Comments: '',
                Invoices: [
                    {
                        Module: 'SD',
                        InvoiceNum: props?.InvoiceData?.callInfo?.invoiceNum.toString(),
                        Amount: finalAmount
                    }
                ]
            }
        })
            .then((res: any) => {
                setLoading(false)
                if (res.success == true) {
                    // setIsPaymentDone(false)
                    toast.success('Payment done successfully')
                    getPaymentData();
                    handleClose();
                } else {
                    toast.error(res?.errorInfo?.message)
                }
            })
            .catch((e) => {
                setLoading(false)
                toast.error(e?.response?.data?.errorInfo?.message)
                paymentResponse.current = null;
                // setIsPaymentDone(false)
            })
    }

   const addACHCard = (data: any) => {
        setLoading(true) 
        var value = data && JSON.parse(data)
        WebService.postAPI({
            action: `api/CreditCard/ChargeWithTokenMultipleInvoicesACHCard`,
            body: {
                CompanyCode: props?.code,
                ACHCardToken: value?.gatewayResponse?.hostedPaymentsAccountId,
                BillTo: props?.InvoiceData?.billTo?.billTo,
                AmountToCharge: finalAmount,
                UserNumber: '',
                UserName: 'CUSTOMER',
                UserType: 'C',
                TransactionFee: 0,
                sendReceiptToEmail: '',
                sendReceiptToPhone: '',
                Comments: '',
                Invoices: [
                    {
                        Module: 'SD',
                        InvoiceNum: props?.InvoiceData?.callInfo?.invoiceNum.toString(),
                        Amount: finalAmount
                    }
                ]
            }
        })
            .then((res: any) => {
                setLoading(false)
                if (res.success == true) {
                    toast.success('Payment done successfully3')
                    getPaymentData();
                    handleClose();
                } else {
                    toast.error(res?.errorInfo?.message)
                }
            })
            .catch((e) => {
                setLoading(false)
                toast.error(e?.response?.data?.errorInfo?.message)
                paymentResponse.current = null;
                // setIsPaymentDone(false)
            })
    }

    return <>
        <Loader show={isLoading} />
        <Modal show={show} onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Payment</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="card-view">
                    <div className="col-12 d-flex">
                        <div className="col-6">
                            <Label title="Amount" />
                            <div>
                                <input type="text" className="form-control input" defaultValue={downPayment ? HelperService.getCurrencyFormatter(downPayment) : '0.00'} value={finalAmount ?  HelperService.getCurrencyFormatter(finalAmount) : '0.00'} onChange={(e) => setFinalAmount(e.target?.value)} onKeyPress={(e) =>
                                    HelperService.allowOnlyNumericValue(e)
                                } onBlur={(e) => HelperService.formateUptoTwoDecimal(e)} readOnly={!isAmountEditable} />
                            </div>
                        </div>
                        {
                            feeData?.transactionFeeEnabled &&  selectedCard !== 'NEW_ACH_CARD' &&

                            (!feeData?.checkSalesAmtMin || feeData?.checkSalesAmtMin && Number(finalAmount) > Number(feeData?.salesAmountLowerCeiling)) &&
                            <div className="col-5 ms-3">
                                <Label title={feeData?.transactionFeeLabel} />
                                <div className="fee">{((feeData?.transactionFeePerc / 100) * finalAmount).toFixed(2)}</div>
                            </div>
                        }
                    </div>
                    {
                        savedCardsData.length > 0 && savedCardsData.map((res) => {
                            return (
                                <>
                                    {
                                        res.cardType?.toUpperCase() == "VISA" &&
                                        <>
                                            <div className="d-flex">
                                                <input type="radio" className="payment-radio" checked={selectedCard == res.sequence ? true : false} onChange={() => setSelectedCard(res.sequence)} />
                                                <div className="credit-card visa selectable">
                                                    <div className="credit-card-last4">
                                                        {res.last4digits}
                                                    </div>
                                                    <div className="credit-card-expiry">
                                                        {res.cardExpiryMonth}/{res.cardExpiryYear}
                                                    </div>
                                                    <div className="card-holder-name">{res.cardHolderName}</div>
                                                </div>
                                            </div>
                                        </>
                                    }
                                    {
                                        res.cardType?.toUpperCase() == 'MC' &&
                                        <>
                                            <div className="d-flex">
                                                <input type="radio" className="payment-radio" checked={selectedCard == res.sequence ? true : false} onChange={() => setSelectedCard(res.sequence)} />
                                                <div className="credit-card mastercard selectable">
                                                    <div className="credit-card-last4">
                                                        {res.last4digits}
                                                    </div>
                                                    <div className="credit-card-expiry">
                                                     {res.cardExpiryMonth}/{res.cardExpiryYear}
                                                    </div>
                                                    <div className="card-holder-name">{res.cardHolderName}</div>
                                                </div>
                                            </div>
                                        </>
                                    }
                                    {
                                        res.cardType?.toUpperCase() == "ACH" &&
                                        <>
                                            <div className="d-flex">
                                                <input type="radio" className="payment-radio" checked={selectedCard == res.sequence ? true : false} onChange={() => setSelectedCard(res.sequence)} />
                                                <div className="credit-card ach selectable">
                                                    <div className="credit-card-last4">
                                                        {res.last4digits}
                                                    </div>
                                                     <div className="credit-card-expiry">
                                                        {(res.cardExpiryMonth != null || res.cardExpiryYear != null) && (
                                                            <>
                                                            {res.cardExpiryMonth}/{res.cardExpiryYear}
                                                            </>
                                                        )}
                                                    </div>
                                                    <div className="card-holder-name">{res.cardHolderName}</div>
                                                </div>
                                            </div>
                                        </>
                                    }
                                </>
                            )
                        })
                    }
                    <div className="d-flex">
                        <input type="radio" className="payment-radio" checked={selectedCard == 'NEW_CARD' ? true : false} onChange={() => setSelectedCard('NEW_CARD')} />
                        <div className="add-credit-card">
                            <PlusSquare className="me-2" /> Add New Card
                        </div>
                    </div>
                    { isACHEnabled &&   <div className="d-flex">
                        <input type="radio" className="payment-radio" checked={selectedCard == 'NEW_ACH_CARD' ? true : false} onChange={() => setSelectedCard('NEW_ACH_CARD')} />
                        <div className="add-credit-card">
                            <PlusSquare className="me-2" /> Add New ACH Card
                        </div>
                    </div>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                {
                    <div style={{ textAlign: "center" }}>
  <span>
    {selectedCard === 'NEW_ACH_CARD'
      ? ''
      : `Program Fee $${Number(total_amount).toFixed(2)}`}
  </span>
</div>
                }
                {
                    finalAmount >= 1 &&
                    <Button
                        label={
                            (selectedCard === 'NEW_CARD' || selectedCard === 'NEW_ACH_CARD')
                            ? `Add & Pay $${
                                (
                                    Number(finalAmount) +
                                    (selectedCard === 'NEW_ACH_CARD' ? 0 : Number(total_amount))
                                ).toFixed(2)
                                }`
                            : `Pay $${
                                (
                                    Number(finalAmount) +
                                    (selectedCard === 'NEW_ACH_CARD' ? 0 : Number(total_amount))
                                ).toFixed(2)
                                }`
                        }
                        size="medium" onClick={() => {
                        if (selectedCard == 'NEW_CARD') {
                            setShow(false)
                            openModal()
                        }else if (selectedCard == 'NEW_ACH_CARD') {
                            if(((Number(finalAmount) + Number(total_amount)).toFixed(2))>achMaxAmount)
                            {
                                toast.error('Total amount should not exceeded ACH Max Amount allowed('+achMaxAmount+')')
                    
                            }else{
                            setShow(false)
                            openModal()
                            }
                        } else {
                            setShow(false)
                            onMakePayment()
                        }
                    }} />
                }

            </Modal.Footer>
        </Modal>
        <Row className="mb-2 align-items-center">
            <Col md={6}>
            </Col>
        </Row>

        <Card className="content-card card-shadow p-0 ">
            <Card.Body className="py-2 text-dark">
                {props.showLoader === true ?
                    <div style={{ textAlign: "center" }}>
                        <img
                            style={{ position: "relative", height: 79 }}
                            src={loader}
                            alt="No loader found"
                        />
                        <div style={{ position: "relative", color: "white" }}>
                            Loading...
                        </div>
                    </div> :
                    <>
                        <Row className="mb-3 pt-1">
                            <Col >
                                <p className="mb-0 font-w-medium font-14">Invoice #</p>
                                <p className="font-14 mb-0">{invoiceData?.callInfo?.invoiceNum ? invoiceData?.callInfo?.invoiceNum : '-'}</p>
                            </Col>
                            <Col >
                                <p className="mb-0 font-w-medium font-14">Invoice Date</p>
                                <p className="font-14 mb-0">{invoiceData?.callInfo?.invoiceDate ? moment(invoiceData?.callInfo?.invoiceDate, 'YYYY-MM-DD').format('MM/DD/YY') : '-'}</p>
                            </Col>
                            {/* {
                                props.type != 'SIGN_INVOICE' &&
                                <Col >
                                    <p className="mb-0 font-w-medium font-14">Service Call #</p>
                                    <p className="font-14 mb-0">{invoiceData?.location?.smNum ? invoiceData?.location?.smNum : '-'}</p>
                                </Col>
                            } */}
                            {
                                props.type != 'SIGN_INVOICE' &&
                                <Col >
                                    <p className="mb-0 font-w-medium font-14">Customer PO</p>
                                    <p className="font-14 mb-0">{invoiceData?.callInfo?.poNum ? invoiceData?.callInfo?.poNum : '-'}</p>
                                </Col>
                            }
                            {
                                props.type == 'SIGN_INVOICE' &&
                                <Col >
                                    <p className="mb-0 font-w-medium font-14">Invoice Total</p>
                                    <p className="font-14 mb-0">{invoiceData?.callInfo?.invTotalAmt ? "$" + HelperService.getCurrencyFormatter(invoiceData?.callInfo?.invTotalAmt) : '-'}</p>
                                </Col>
                            }
                        </Row>
                        {
                            props.type != 'SIGN_INVOICE' &&
                            <Row className={props.receipt ? 'mb-2 d-none' : "mb-2"}>
                                <Col>
                                    <p className="mb-0 font-w-medium font-14">Invoice Total</p>
                                    <p className="font-14 mb-0">{invoiceData?.callInfo?.invTotalAmt ? "$" + HelperService.getCurrencyFormatter(invoiceData?.callInfo?.invTotalAmt) : '-'}</p>
                                </Col>
                                <Col>
                                    <p className="mb-0 font-w-medium font-14">Paid Amount</p>
                                    <p className="font-14 mb-0">{invoiceData?.callInfo?.amountPaid ? "$" + HelperService.getCurrencyFormatter(invoiceData?.callInfo?.amountPaid) : '-'}</p>
                                </Col>
                                <Col>
                                    <div className='d-flex'>
                                        <div>
                                            <p className="mb-0 font-w-medium font-14">Balance Due</p>
                                            <p className="font-14 mb-0">{invoiceData?.callInfo?.amountDue ? "$" + HelperService.getCurrencyFormatter(invoiceData?.callInfo?.amountDue) : '-'}</p>
                                        </div>
                                        <div className="ms-4 mt-2">
                                            {
                                                downPayment > 0 ? <Button label={`Pay $ ${HelperService.getCurrencyFormatter(downPayment)}`} size='medium' onClick={() => { getSavedCards(); setFinalAmount(downPayment); getAuthorizationKey(); }} /> : '-'
                                            }
                                        </div>
                                    </div>
                                </Col>
                                {/* <Col>
                                    
                                </Col> */}
                            </Row>
                        }
                    </>
                }
            </Card.Body>
        </Card>
    </>;
};

export default InvoiceDetailHeader;


